import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from 'axios';
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { required, decimal } from "vuelidate/lib/validators";

export default {
  name: "skillEdit",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      employeeId: this.$route.params.id,
      type: this.$route.params.type,
      empData: {
        employeeId: null,
        empNumber: '',
        positionId: null,
        startDate: '',
        totalSalary: 0,
        salaryComponents: [],
      },
      skills: [],
      employeeList: [],
      employeeOptions: [],
      positionOptions: [],
      submitted: false,
      disabled: false,
      isLoading: false,
      CONFIG,
    };
  },

  validations: {
    empData: {
      employeeId: { required },
      positionId: { required },
      startDate: { required },
      basicSalary: { required },
      salaryComponents: {
        $each: {
          amount: {
            decimal,
            maxDigits: (value) => !value || /^\d{1,8}(\.\d{1,2})?$/.test(value),
            twoDecimal: (value) => !value || /^\d+(\.\d{1,2})?$/.test(value),
          }
        }
      }
    }
  },

  watch: {
    'empData.positionId': function(newVal) {
      if (newVal && this.positionOptions.length > 0) {
        const selectedPosition = this.positionOptions.find(p => p.id == newVal);

        if (selectedPosition) {
          this.empData.basicSalary = selectedPosition.basic_salary;
          this.calculateTotal();
        }
      }
    }
  },
  methods: {
    calculateTotal() {
      const basic = parseFloat(this.empData.basicSalary) || 0;
      const componentsSum = this.empData.salaryComponents.reduce((acc, item) => {
        return acc + (parseFloat(item.amount) || 0);
      }, 0);

      const total = basic + componentsSum;
      this.empData.totalSalary = total.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    async getEditData() {
      const validTypes = [
        this.CONFIG.EMPLOYEE_TYPE.ADMIN.toString(),
      this.CONFIG.EMPLOYEE_TYPE.TEACHER.toString()
      ];
  
      if (!this.employeeId || !validTypes.includes(this.type.toString())) {
        this.handleInvalidAccess("Invalid ID Access Detected");
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.get(`/skill/edit/${this.employeeId}/${this.type}`);
        if (!response.data || !response.data.detail) {
          this.handleInvalidAccess("Invalid ID Access Detected");
          return;
        }
        const data = response.data;
        this.employeeOptions = data.employeeOptions;
        this.positionOptions = data.positionOptions;

        if (data.detail) {
          this.empData.employeeId = data.detail.employee_id.toString();
          this.empData.positionId = data.detail.position_id ? data.detail.position_id.toString() : null;

          this.empData.empNumber = data.detail.emp_no;
          this.empData.startDate = data.detail.start_date;
          this.empData.basicSalary = parseFloat(data.detail.basic_salary || 0).toFixed(2);
          this.empData.basicSalaryAttrId = data.detail.basic_salary_id
          this.empData.salaryComponents = data.detail.components.map(comp => ({
            ...comp,
            amount: parseFloat(comp.amount).toFixed(2)
          }));

          this.calculateTotal();
        }
      } catch (error) {
        console.error("Failed To Fetch Data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async update() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;
      try {
        const allAttributes = [
          { 
            attribute_id: this.empData.basicSalaryAttrId, 
            amount: this.empData.basicSalary
          },
          ...this.empData.salaryComponents.map(item => ({
            attribute_id: item.attribute_id,
            amount: item.amount
          }))
        ];

        const payload = {
          employee_id: this.employeeId,
          employee_type: this.type,
          position_id: this.empData.positionId,
          start_date: this.empData.startDate,
          basic_salary: this.empData.basicSalary, 
          basic_salary_attr_id: this.empData.basicSalaryAttrId,
          skills: this.empData.salaryComponents.map(item => ({
            attribute_id: item.attribute_id,
            amount: item.amount
          })),
          all_attributes: allAttributes
        };
        const response = await axios.post(`/skill/update/${this.employeeId}/${this.type}`, payload);
        if (response.status === 200) {
          this.$notification.success("Skill Data Updated Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({
            name: 'skillList'
          })
        }
      } catch (error) {
        console.error("Failed to update skill data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    handleInvalidAccess(message) {
      this.$notification.error(message, {
        timer: 3,
        position: "bottomCenter"
      });
      this.$router.push({ name: 'skillList' });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getEditData();
  },
};
